import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ff50d9e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff50d9e')) {
      api.createRecord('1ff50d9e', component.options)
    } else {
      api.reload('1ff50d9e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1ff50d9e", function () {
      api.rerender('1ff50d9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjSelectMaterial/index.vue"
export default component.exports